import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import superagent from 'superagent';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import { message } from 'antd';
import { MyStore } from 'kts-platform-frame/redux';
const { env } = MyStore.instance.getState();

class ModulesAction extends ActionBasic<ModulesState> {

    public getUrl = async (pathName: string) => {
        // 开发环境 = 'debug',
        // 生产环境 = 'production',
        // 测试环境 = 'test',
        // 演示环境 = 'demo',
        // 腾讯演示环境 = 'tdemo',
        let envType = new Map([
            ['debug', '.dev'],
            ['dev', '.dev'],
            ['production', ''],
            ['test', '.test'],
            ['demo', '.demo'],
        ]);
        this.modulesState.previewUrl = `https://preview.kingxunlian.com:18080/web-reader/reader?file=http://biz-gateway${envType.get(env.NODE_ENV)}.kingxunlian.com/invoicing/download/${pathName}`;
        this.modulesState.downloadUrl = `https://biz-gateway${envType.get(env.NODE_ENV)}.kingxunlian.com/invoicing/download/${pathName}`;
        this.setModulesState();
    }
    public goLogin = async () => {
        let envType = new Map([
            ['debug', '.dev'],
            ['dev', '.dev'],
            ['production', ''],
            ['test', '.test'],
            ['demo', '.demo'],
        ]);
        window.open(`https://go${envType.get(env.NODE_ENV)}.kingxunlian.com/`);
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/modules/Home/PreviewPublic/Modules.Action.ts